export default __webpack_public_path__ + "static/media/menuicon.e0ae2c04.svg";